import React from 'react'
import Styled from 'styled-components'
// import { transparentize } from 'polished'

import AddMarker from 'components/AddMarker'

const Container = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;

  ${props => (props.isBrowserOpen || props.isEditorOpen) && `
    cursor: default;
  `}
`

const HitArea = Styled.div`
  position: absolute;
  ${props => props.anchor}: 0;
  left: 0;
  width: 100%;
  height: 2rem;

  ${props => !(props.isBrowserOpen || props.isEditorOpen) && `
    &:hover > * {
      display: block;
    }
  `}

  ${props => props.isDisabled && `
    background: blue;
  `}
`

const AddMarkerContainer = Styled.div`
  position: absolute;
  left: 50%;
  max-width: calc(100% - 6rem);
  display: none;

  ${props => props.anchor === 'top' && `
    top: 0;
    transform: translate(-50%, -50%);
  `}

  ${props => props.anchor === 'bottom' && `
    bottom: 0;
    transform: translate(-50%, 50%);
  `}
`

export default props => (
  <Container
    data-selector="page-component-touchable"
    isOpen={props.isOpen}
    isBrowserOpen={props.isBrowserOpen}
    isEditorOpen={props.isEditorOpen}
    onClick={(e) => {
      if (props.isOpen) {
        e.preventDefault()
        e.stopPropagation()
      }

      props.onClick()
    }}
  >
    {['top', 'bottom'].map((anchor, index) => (
      <HitArea
        data-selector="page-component-touchable"
        key={anchor}
        anchor={anchor}
        isBrowserOpen={props.isBrowserOpen}
        isEditorOpen={props.isEditorOpen}
        onClick={(e) => {
          if (!props.isBrowserOpen && !props.isEditorOpen) {
            e.preventDefault()
            e.stopPropagation()

            props.onClickAdd(index)
          }
        }}
      >
        <AddMarkerContainer
          anchor={anchor}
        >
          <AddMarker />
        </AddMarkerContainer>
      </HitArea>
    ))}
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/PageComponentTouchable/index.js